import React, { Component } from 'react';
import { Table, Tag, Button, Select, Popconfirm } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';
const Option = Select.Option;

@inject('store')
@observer
export class SubscriptionsTable extends Component {
    async componentDidMount() {
        await this.props.store.billingStore.getSubscriptions();

        this.interval = setInterval(
            async () => await this.props.store.billingStore.getSubscriptions(),
            10000
        );
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleAssignBot(subscription, selectedBot) {
        if (subscription.bot_type !== 'apex') {
            const botConfig = this.props.store.botConfigStore.configurations.find(
                (c) => c._id === selectedBot
            );
            return this.props.store.billingStore.assignBotToSubscription(subscription, botConfig);
        }
        const pool = this.props.store.botStore.poolBindings[selectedBot];
        const botConfig = this.props.store.botStore.bots[pool.bot_config];
        this.props.store.billingStore.assignBotToSubscription(subscription, botConfig);
        this.props.store.billingStore.getSubscriptions();
    }

    render() {
        const { currentUser } = this.props.store.userStore;
        const { timezone } = currentUser;
        return (
            <Table
                rowKey={'_id'}
                dataSource={this.props.store.billingStore.subscriptions}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: '_id',
                        key: '_id',
                    },
                    {
                        title: 'Status',
                        dataIndex: 'status',
                        key: 'status',
                        render(text, o) {
                            return <Tag color={text === 'ACTIVE' ? '#29c0b1' : null}>{text}</Tag>;
                        },
                    },
                    {
                        title: 'Attached to Bot',
                        dataIndex: 'bot_id',
                        key: 'bot_id',
                        render: (text, o) => {
                            if (o.status !== 'ACTIVE') return <span>None</span>;

                            return (
                                <Select
                                    style={{ width: '100%' }}
                                    value={text}
                                    onChange={this.handleAssignBot.bind(this, o)}
                                >
                                    <Option value={''}>None Selected</Option>
                                    {o.bot_type === 'apex'
                                        ? Object.keys(this.props.store.botStore.poolBindings).map(
                                              (poolId) => {
                                                  const pool = this.props.store.botStore
                                                      .poolBindings[poolId];
                                                  const bot = this.props.store.botStore.bots[
                                                      pool.bot_config
                                                  ];
                                                  if (!bot) return null;
                                                  return (
                                                      <Option value={pool.id} key={pool.id}>
                                                          {bot.name}
                                                      </Option>
                                                  );
                                              }
                                          )
                                        : o.bot_type === 'odyssey'
                                        ? this.props.store.botConfigStore.configurations
                                              .filter((b) => b.type === 'odyssey')
                                              .map((bot) => {
                                                  return (
                                                      <Option value={bot._id} key={bot._id}>
                                                          {bot.name}
                                                      </Option>
                                                  );
                                              })
                                        : this.props.store.botConfigStore.configurations
                                              .filter((b) => b.type === 'mako')
                                              .map((bot) => {
                                                  return (
                                                      <Option value={bot._id} key={bot._id}>
                                                          {bot.name}
                                                      </Option>
                                                  );
                                              })}
                                </Select>
                            );
                        },
                    },
                    {
                        title: 'Product',
                        dataIndex: 'subscription_name',
                        key: 'subscription_name',
                    },
                    {
                        title: 'Payment Method',
                        dataIndex: 'payment_method',
                        key: 'payment_method',
                    },
                    {
                        title: 'Next Billing Date',
                        dataIndex: 'end_date',
                        key: 'end_date',
                        render(text) {
                            return moment(text).tz(timezone).format('DD/MM/YYYY');
                        },
                    },
                    {
                        title: 'Actions',
                        dataIndex: '',
                        key: '',
                        render: (text, o) => {
                            if (o.status === 'ACTIVE' && o.payment_method === 'paypal') {
                                return (
                                    <Popconfirm
                                        title="Are you sure you want to cancel this subscription?"
                                        onConfirm={() =>
                                            this.props.store.billingStore.cancelSubscription(o._id)
                                        }
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button type={'danger'}>Cancel</Button>
                                    </Popconfirm>
                                );
                            }

                            return null;
                        },
                    },
                ]}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/SubscriptionsView/SubscriptionsTable.js